// import { decrypt, encrypt } from './localStorageED';

// const SECRET_CODE = import.meta.env.VITE_REACT_STN_SECRET_KEY;

export const setLocalStorageData = (key, data) => {
  // const encrypted = encrypt(data, SECRET_CODE)
  localStorage.setItem(key, data);
};

export const getLocalStorageData = (key) => {
  const data = localStorage.getItem(key);
  if (!data) return null;
  // return decrypt(data, SECRET_CODE)
  return data;
};
